import { Box } from '@mui/material';
import InitialMessage from './InitialMessage';
import BlocksMessage from './copilot-component/BlocksMessage';
import PipelineMessage from './copilot-component/PipelineMessage';
import ChatBubble from './copilot-component/ChatBubble';
import LogsTerminal from './copilot-component/LogsTerminal';
import TableMessage from './copilot-component/TableMessage';
import { JsonViewer } from './copilot-component/JsonViewer';

// Utility function to merge consecutive logs
function mergeConsecutiveLogs(data) {
  const result = [];
  let logBuffer = [];

  data.forEach((item) => {
    if (item.type.toLowerCase() === 'info') {
      logBuffer.push(item.content);
    } else {
      if (logBuffer.length > 0) {
        result.push({
          type: 'info',
          sender: 'copilot',
          content: [...logBuffer],
        });
        logBuffer = [];
      }
      result.push(item);
    }
  });

  // Push remaining logs at end
  if (logBuffer.length > 0) {
    result.push({
      type: 'info',
      sender: 'copilot',
      content: [...logBuffer],
    });
  }

  return result;
}

function CopilotFullScreenChatWindow({
  data,
  handleAddNode,
  handleAddPipeline,
  chatHistoryEndRef,
  sendUserMessage,
  setUserMessage,
}) {
  const mergedData = mergeConsecutiveLogs(data);

  return (
    <Box className="chat-window" sx={{ fontSize: '1rem' }}>
      {mergedData?.length === 0 && (
        <InitialMessage showAvatar setUserMessage={setUserMessage} sendUserMessage={sendUserMessage} />
      )}

      {mergedData?.map((chat, index) => {
        const previousSender = index > 0 ? mergedData[index - 1].sender : null;
        const showAvatar = chat.sender !== previousSender;

        const nextType = index < mergedData.length - 1 ? mergedData[index + 1].type : null;
        const showBlink = chat.type === nextType;

        if (chat.type.toLowerCase() === 'info') {
          return (
            <LogsTerminal
              key={index}
              // type={chat.type}
              logs={chat.content}
              withAvatar
              showAvatar={showAvatar}
              showBlink={showBlink}
            />
          );
        }
        if (chat.type.toLowerCase() === 'plan') {
          return (
            <JsonViewer
              key={index}
              content={chat.content}
              withAvatar
              showAvatar={showAvatar}
              type={chat.type}
            />
          );
        }
        if (chat.type.toLowerCase() === 'table') {
          return (
            <TableMessage
              key={index}
              tableData={chat.content}
              withAvatar
              showAvatar={showAvatar}
              type={chat.type}
            />
          );
        }

        if (chat.type.toLowerCase() === 'text') {
          return (
            <ChatBubble key={index} sender={chat.sender} message={chat.content} showAvatar={showAvatar} withAvatar />
          );
        }

        if (chat.type.toLowerCase() === 'blocks') {
          return (
            <BlocksMessage
              key={index}
              blocks={chat.content}
              handleAddNode={handleAddNode}
              blockSize={{ width: '80px', height: '80px' }}
              paddingX={10}
            />
          );
        }

        if (chat.type.toLowerCase() === 'pipeline') {
          return (
            <PipelineMessage key={index} pipeline={chat.content} handleAddPipeline={handleAddPipeline} paddingX={10} />
          );
        }

        return null;
      })}

      <div ref={chatHistoryEndRef} />
    </Box>
  );
}

export default CopilotFullScreenChatWindow;
